'use client';

import { FC } from 'react';
import { RadioButtonComponentProps } from './types';
import styles from './RadioButton.module.css';
import { clsx } from 'clsx';

const RadioButton: FC<RadioButtonComponentProps> = ({
  selected,
  value,
  label,
  radioClassName,
  radioLabelClassName,
  onChange,
  error,
  radioTitleClassName,
  radioOptionClassName,
}) => {
  const labelWithoutSpaces = label?.toString().replace(/\s/g, '')
  return (
      <label className={clsx(styles.radioLabel, radioLabelClassName, { [styles.radioLabelError]: error })}>
        <div className={clsx(styles.radioContainer, radioClassName)}>
          <input
            data-testid={`radio-button-${labelWithoutSpaces}`}
            type="radio"
            value={value}
            onChange={() => onChange(value)}
            checked={selected}
            className={styles.radioInput}
          />
          <div className={clsx(styles.radioIcon, { [styles.radioIconActive]: selected }, radioOptionClassName)} />
        </div>
        {typeof label === 'string' ? (
          <span className={clsx(styles.radioTitle, radioTitleClassName)}>{label}</span>
        ) : (
          <div>{label}</div>
        )}
      </label>
  )
};

export default RadioButton;
